module.exports = __webpack_public_path__ + "img/grade-a-purple.26d67158.svg";